<template>
  <table class="table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="min-width">№</th>
        <th scope="col" class="min-width">Club</th>
        <th scope="col" class="min-width">Score</th>
        <th></th> <!-- empty column for alignment -->
      </tr>
    </thead>
    <tr
      v-for="(record, index) in rating"
      :key="record.entityId"
    >
      <td class="num">
        {{index + 1 | getFormattedNumber}}
      </td>
      <td>
        <club-link :clubId="record.entityId" />
      </td>
      <td class="num">
        {{record.score | getFormattedNumber}}
      </td>
      <td></td>
    </tr>
  </table>
</template>

<script>
import ClubLink from '../ClubLink.vue';

export default {
  name: 'ClubRating',

  components: {
    ClubLink,
  },

  props: {
    rating: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.num {
  text-align: right;
}

.min-width {
  width: 1px;
}
</style>
